import request from '@/utils/request'
//import getBrowserLang from '@/i18n/index'

// 获取企业列表
export function getCompanyTree(data) {  
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN' // getBrowserLang()
  return request({
    url: 'api/company/companytree',
    method: 'post',
    data
  })
}
//获取企业网关列表
export function getCompanyGatewayTree(data) {  
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: 'api/company/companygatewaytree',
    method: 'post',
    data
  })
}

//获取企业设备列表
export function getCompanyDeviceTree(data) {  
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: 'api/company/companydevicetree',
    method: 'post',
    data
  })
}

//企业列表
export function getCompanyList(data) {  
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: 'api/company/list',
    method: 'post',
    data
  })
}
//增加企业
export function getCompanyAdd(data) {  
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: 'api/company/add',
    method: 'post',
    data
  })
}

//编辑
export function getCompanyEdit(data) {  
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: 'api/company/edit',
    method: 'post',
    data
  })
}

//删除企业
export function getCompanyDelete(data) {
    data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: 'api/company/delete',
    method: 'post',
    data
  })
}
